import React, { useContext, useEffect, useState } from 'react';
import { ColumnDirective, ColumnsDirective, GridComponent } from '@syncfusion/ej2-react-grids';
import { Box, Typography } from '@material-ui/core';
import { Button, TextField } from '@mui/material';
import { createContext } from 'react';

// WORK AROUND CONTEXT FOR Handling Doc Click
export const DocButtonContext = createContext({
  handleDocketDocs: () => {},
});

function camelCaseToLabel(text) {
  return text.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
}

const docCountMap = {
  wH_Docket: 'whDocs',
  permit: 'permitDocs',
  supplierDocket: 'supplierDocs',
  wB_Docket: 'wbDocs',
  lastLoad: 'lastLoadDocs',
};

const DocButton = props => {
  const { handleDocketDocs, docketMainData } = useContext(DocButtonContext);

  const columnField = props.column.field;
  const countField = docCountMap[columnField];

  const count = docketMainData?.[countField] ?? 0;
  const hasDocs = count > 0;

  return (
    <Button
      onClick={() => handleDocketDocs(props)}
      sx={{
        fontSize: 12,
        fontWeight: hasDocs ? 600 : 500,
        color: hasDocs ? 'primary' : 'text.secondary',
        width: '100%',
        textTransform: 'none',
        padding: 0,
        minWidth: 0,
        justifyContent: 'flex-start',

        '&:hover': {
          backgroundColor: 'transparent',
          color: 'primary.main',
          textDecoration: hasDocs ? 'underline' : 'none',
        },
      }}>
      {hasDocs ? `View Docs (${count})` : 'Add Docs'}
    </Button>
  );
};

const SyncfusionDataTable = ({
  columns,
  data,
  sectionName,
  handleDocketInfoEdit,
  headerUI,
  minWidth,
  handleDocketDocs,
  docketMainData,
}) => {
  const editOptions = { allowEditing: true, mode: 'Dialog' };

  const [docketSectionData, setDocketSectionData] = useState([]);
  useEffect(() => {
    setDocketSectionData(data);
  }, [data]);
  const handleRowDoubleClick = props => {
    handleDocketInfoEdit(sectionName, props.rowData);
  };

  return (
    <DocButtonContext.Provider value={{ docketMainData, handleDocketDocs }}>
      <Box
        component={'div'}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          borderRadius: '0.5rem',
        }}>
        <Typography variant="h3" style={{ paddingBottom: '.25rem', textTransform: 'capitalize' }}>
          {camelCaseToLabel(sectionName)} {headerUI ? headerUI : ''}
        </Typography>
        <div style={{ overflow: 'auto', height: '100%', width: '100%', borderRadius: 'inherit' }}>
          <GridComponent
            dataSource={docketSectionData}
            allowTextWrap={true}
            style={{
              minHeight: 'auto !important',
              minWidth: minWidth,
            }}
            recordDoubleClick={handleRowDoubleClick}>
            <ColumnsDirective>
              {columns.map((column, index) => {
                const commonProps = {
                  field: column.key,
                  headerText: column.label,
                  width: column.width || 'auto',
                  key: `${column.key}_${sectionName}_${index}`,
                  visible: column.hidden ? false : true,
                };

                if (column.formatter) {
                  return <ColumnDirective {...commonProps} formatter={column.formatter} />;
                }

                if (column.isDocument) {
                  return <ColumnDirective {...commonProps} template={DocButton} />;
                }

                return <ColumnDirective {...commonProps} />;
              })}
            </ColumnsDirective>
          </GridComponent>
        </div>
      </Box>
    </DocButtonContext.Provider>
  );
};

export default SyncfusionDataTable;
